import { render, staticRenderFns } from "./HighlightsBtn.vue?vue&type=template&id=3fde70ba&lang=html&"
import script from "./HighlightsBtn.vue?vue&type=script&lang=js&"
export * from "./HighlightsBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports